<template>
  <div class="login-container" :style="'background:url(' + img + ');background-size:100% 100%'">
    <el-row type="flex" class="row-bg" justify="center">
      <!-- <el-col :span="13"> -->
      <img class="loginlogo" src="../../assets/loginLogo.png" alt="" />
      <!-- </el-col :span="10"> -->
      <!-- <el-col class="loginItem"></el-col> -->
      <div class="loginItem">
        <div class="title-container">
          <h3 class="title">格力线上回收管理平台</h3>
          <h3 class="line">https://xiaogelv.gree.com</h3>
        </div>
        <el-form ref="loginForm" :model="loginForm" class="login-form" auto-complete="on" label-position="left">
          <div v-if="isEdit" class="login">
            <span class="registered">账户密码登录</span>

            <el-form-item prop="username" class="userNameItem">
              <span class="svg-container">
                <svg-icon icon-class="user" />
              </span>
              <el-select
                v-model="loginForm.username"
                placeholder="账户"
                filterable
                allow-create
                default-first-option
                :reserve-keyword="false"
                @change="handleUsernameChange"
                style="width: 100%"
              >
                <el-option v-for="item in recentUsernames" :key="item" :label="item" :value="item">
                  <span style="float: left">{{ item }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px; cursor: pointer" @click.stop="removeUsername(item, $event)">
                    删除
                  </span>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="password" class="passWordItem">
              <span class="svg-container">
                <svg-icon icon-class="password" />
              </span>
              <el-input
                v-if="!usePasswordAutofillGuard"
                :key="passwordType"
                ref="password-non-guard"
                v-model="loginForm.password"
                :type="passwordType"
                placeholder="密码"
                name="password"
                tabindex="2"
                auto-complete="off"
                @keyup.enter.native="handleLogin"
              />
              <el-input
                v-else
                :key="'password-guard-' + showPassword"
                ref="password-guard"
                v-model="loginForm.password"
                :class="['password-mask', { 'password-plain': showPassword }]"
                type="text"
                placeholder="密码"
                name="login-passcode"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                tabindex="2"
                @keyup.enter.native="handleLogin"
              />
              <span class="show-pwd" @click="showPwd">
                <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
              </span>
            </el-form-item>

            <div class="userService">
              <div class="forgotPassword" @click="isEdit = false">修改密码</div>
            </div>

            <el-button :loading="loading" size="medium" type="primary" style="width:100%;margin-bottom:30px;padding:16px;" @click.native.prevent="handleLogin">
              <span class="loginText">登&nbsp;录</span>
            </el-button>
          </div>

          <div v-else class="loginelse">
            <span class="registered">修改密码</span>

            <el-form-item prop="username" class="userNameItem editMargin">
              <span class="svg-container">
                <svg-icon icon-class="user" />
              </span>
              <el-input v-model="resetForm.username" ref="username" placeholder="账户" name="username" type="text" tabindex="1" auto-complete="on" />
            </el-form-item>

            <el-form-item prop="password" class="passWordItem editMargin">
              <span class="svg-container">
                <svg-icon icon-class="password" />
              </span>
              <el-input
                v-model="resetForm.oldPassword"
                :key="passwordType"
                ref="password"
                :type="passwordType"
                placeholder="旧密码"
                name="password"
                tabindex="2"
                auto-complete="on"
              />
              <span class="show-pwd" @click="showPwd">
                <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
              </span>
            </el-form-item>
            <el-form-item prop="password" class="passWordItem editMargin">
              <span class="svg-container">
                <svg-icon icon-class="password" />
              </span>
              <el-input
                :key="passwordType"
                ref="password"
                :type="passwordType"
                placeholder="新密码"
                name="password"
                tabindex="2"
                auto-complete="on"
                v-model="resetForm.newPassword"
              />
              <span class="show-pwd" @click="showPwd">
                <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
              </span>
            </el-form-item>
            <el-form-item prop="password" class="passWordItem editMargin">
              <span class="svg-container">
                <svg-icon icon-class="password" />
              </span>
              <el-input
                :key="passwordType"
                ref="password"
                :type="passwordType"
                placeholder="确认新密码"
                name="password"
                tabindex="2"
                auto-complete="on"
                v-model="resetForm.newPasswordConfirm"
              />
              <span class="show-pwd" @click="showPwd">
                <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
              </span>
            </el-form-item>
            <el-form-item class="userTips">
              <span>温馨提示:密码至少包含8位(需包含数字和字母，不能使用特殊字符)</span>
            </el-form-item>

            <el-button :loading="loading" size="medium" type="primary" style="width:100%;margin-bottom:9px;padding:14px;background:#0094fb" @click="changePws">
              <span class="loginText">修改密码</span>
            </el-button>
            <el-button :loading="loading" size="medium" style="width:100%;margin-bottom:30px;padding:14px;color:#0094fb;margin-left:0px;">
              <span class="loginText" @click="isEdit = true">返回</span>
            </el-button>
          </div>

          <!-- <div class="tips">
        <span style="margin-right:20px;">username: admin</span>
        <span> password: any</span>
      </div> -->
        </el-form>

        <!-- 总部账号首次登录绑定员工编号弹窗 -->
        <el-dialog title="员工身份认证" :visible.sync="bindVisible" width="420px" top="30vh" center :close-on-click-modal="false" :show-close="false">
          <div class="bind-field">
            <span class="bind-label"><span style="color: red;">*</span>员工姓名</span>
            <el-input
              v-model.trim="bindForm.realName"
              placeholder="请输入"
              clearable
              @keyup.enter.native="handleBindSubmit"
            />
          </div>
          <div class="bind-field">
            <span class="bind-label"><span style="color: red;">*</span>员工编号</span>
            <el-input
              v-model.trim="bindForm.account"
              placeholder="请输入"
              clearable
              maxlength="9"
              @input="filterNumber"
              @keyup.enter.native="handleBindSubmit"
            />
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelBind">取 消</el-button>
            <el-button type="primary" :loading="bindLoading" @click="handleBindSubmit">提交认证</el-button>
          </div>
        </el-dialog>
      </div>
    </el-row>
  </div>
</template>

<script>
import { validUsername } from '@/utils/validate'
const defaultResetForm = {
  username: '',
  oldPassword: '',
  newPassword: '',
  newPasswordConfirm: ''
}
export default {
  name: 'Login',
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!validUsername(value)) {
        callback(new Error('Please enter the correct user name'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('The password can not be less than 6 digits'))
      } else {
        callback()
      }
    }
    return {
      isEdit: true,
      keepPassword: false,
      img: require('../../assets/BG60.png'),
      loginForm: {
        username: '',
        password: ''
      },
      resetForm: Object.assign({}, defaultResetForm),
      loginRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur' }]
      },
      loading: false,
      passwordType: 'password',
      redirect: undefined,
      showPassword: false,
      recentUsernames: [],
      // 绑定员工编号弹窗
      bindVisible: false,
      bindLoading: false,
      bindForm: {
        realName: '',
        account: ''
      },
      loginData: null
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  mounted() {
    this.getCookie()
    this.loadRecentUsernames()
  },
  computed: {
    // 根据环境变量判断是否启用防止浏览器记住密码的功能
    // 在生产环境和测试环境生效
    usePasswordAutofillGuard() {
      const env = process.env.NODE_ENV
      return env === 'production'
    },
    shouldPreventPasswordRemember() {
      return this.usePasswordAutofillGuard
    }
  },
  methods: {
    loadRecentUsernames() {
      const stored = localStorage.getItem('recentUsernames')
      if (stored) {
        try {
          this.recentUsernames = JSON.parse(stored)
        } catch (e) {
          this.recentUsernames = []
        }
      }
    },
    saveUsername(username) {
      if (!username) return

      let index = this.recentUsernames.indexOf(username)
      if (index > -1) {
        this.recentUsernames.splice(index, 1)
      }
      this.recentUsernames.unshift(username)

      if (this.recentUsernames.length > 10) {
        this.recentUsernames = this.recentUsernames.slice(0, 10)
      }

      localStorage.setItem('recentUsernames', JSON.stringify(this.recentUsernames))
    },
    handleUsernameChange(value) {
      this.loginForm.username = value
    },
    removeUsername(username, event) {
      event.stopPropagation()
      const index = this.recentUsernames.indexOf(username)
      if (index > -1) {
        this.recentUsernames.splice(index, 1)
        localStorage.setItem('recentUsernames', JSON.stringify(this.recentUsernames))
      }
      if (this.loginForm.username === username) {
        this.loginForm.username = ''
      }
    },
    showPwd() {
      // 切换密码类型用于非 guard 模式
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }

      // 切换 showPassword 用于 guard 模式
      this.showPassword = !this.showPassword

      this.$nextTick(() => {
        // 处理非 guard 模式的焦点
        if (this.$refs['password-non-guard'] && this.$refs['password-non-guard'].$el) {
          const inputElement = this.$refs['password-non-guard'].$el.querySelector('input')
          if (inputElement) {
            inputElement.focus()
          }
        }

        // 处理 guard 模式的焦点
        if (this.$refs['password-guard'] && this.$refs['password-guard'].$el) {
          const inputElement = this.$refs['password-guard'].$el.querySelector('input')
          if (inputElement) {
            inputElement.focus()
          }
        }
      })
    },
    handleLogin() {
      this.saveUsername(this.loginForm.username)

      if (this.keepPassword === true) {
        console.log('checked === true')
        this.setCookie(this.loginForm.username, this.loginForm.password, 7)
        this.getLogin()
      } else {
        console.log('清空 cookie')
        this.clearCookie()
        this.getLogin()
      }
    },
    getLogin() {
      let params = {
        username: this.loginForm.username,
        password: this.encode(this.loginForm.password)
      }
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store
            .dispatch('user/login', params)
            .then(res => {
              console.log(res, 'res')
              this.loading = false
              const data = res && res.data
              this.loginData = data
              if (data && data.authenticated === false) {
                // 未认证（总部账号首次登录需绑定员工信息），弹出输入框
                this.bindForm.realName = ''
                this.bindForm.account = ''
                this.bindVisible = true
              } else {
                this.$router.push({ path: this.redirect || '/' })
              }
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 取消绑定
    cancelBind() {
      this.bindVisible = false
      this.bindLoading = false
      // 清除登录态，可重新登录
      this.$store.dispatch('user/resetToken')
      this.clearCookie()
    },
    // 员工编号仅允许输入数字
    filterNumber() {
      this.bindForm.account = (this.bindForm.account || '').replace(/[^\d]/g, '')
    },
    // 提交绑定员工信息（姓名 + 员工编号）
    handleBindSubmit() {
      const realName = this.bindForm.realName
      const account = this.bindForm.account
      if (!realName) {
        this.$message.warning('请输入姓名')
        return
      }
      if (!account) {
        this.$message.warning('请输入员工编号')
        return
      }
      // 员工编号长度为 9 位
      if (!/^\d{9}$/.test(account)) {
        this.$message.warning('员工编号需为9位数字，请重新输入')
        return
      }
      this.bindLoading = true
      // 复用当前登录的账号密码，追加 realName 和 account 重新调用登录接口完成绑定认证
      const params = {
        username: this.loginForm.username,
        password: this.encode(this.loginForm.password),
        realName,
        account
      }
      this.$store
        .dispatch('user/login', params)
        .then(res => {
          this.bindLoading = false
          if (res && res.statusCode === 200 && res.data && res.data.authenticated !== false) {
            this.$message.success('绑定成功')
            this.bindVisible = false
            this.$router.push({ path: this.redirect || '/' })
          } else {
            this.$message.error((res && res.message) || '绑定认证失败，请确认姓名和员工编号后重新输入')
            this.bindVisible = true
          }
        })
        .catch(() => {
          this.bindLoading = false
          this.bindVisible = true
          this.$message.error((res && res.message) || '绑定认证失败，请确认姓名和员工编号后重新输入')
        })
    },
    //设置cookie
    setCookie(name, pwd, exdays) {
      var exdate = new Date() //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays) //保存的天数
      //字符串拼接cookie
      window.document.cookie = 'userName' + '=' + name + ';path=/;expires=' + exdate.toGMTString()
      window.document.cookie = 'userPwd' + '=' + pwd + ';path=/;expires=' + exdate.toGMTString()
    },
    //读取cookie
    getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ') //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=') //再次切割
          //判断查找相对应的值
          if (arr2[0] == 'userName') {
            this.loginForm.username = arr2[1] //保存到保存数据的地方
          } else if (arr2[0] == 'userPwd') {
            this.loginForm.password = arr2[1]
          }
        }
      }
    },
    //清除cookie
    clearCookie: function() {
      this.setCookie('', '', -1) //修改2值都为空，天数为负1天就好了
    },
    encode(value) {
      // 登录密码加密
      let key = '密'.charCodeAt(0)
      let str = ''
      for (var i = 0; i < value.length; i++) {
        str += value.charCodeAt(i) ^ key
        if (i < value.length - 1) {
          str += '%'
        }
      }
      return str
    },
    changePws() {
      console.log(this.resetForm.newPassword, this.resetForm.newPasswordConfirm, '!111')
      console.log(this.resetForm.newPassword === this.resetForm.newPasswordConfirm, '!222')

      if (!(this.resetForm.newPassword === this.resetForm.newPasswordConfirm)) {
        this.$dialog({
          title: '温馨提示',
          content: '确认密码与新密码不一致，请重新输入！',
          footBtn: false,
          width: '20%',
          dialogType: 'warning'
        })
        return
      }
      let params = {
        password: this.encode(this.resetForm.oldPassword),
        newPassword: this.encode(this.resetForm.newPassword),
        username: this.resetForm.username
      }
      this.HttpService.post('/autoapp-recovery-server-auth/api/recoveryManage/updatePwd', params).then(res => {
        if (res.statusCode != 200) {
          this.$dialog({
            title: '温馨提示',
            content: res.message,
            footBtn: false,
            width: '20%',
            dialogType: 'warning'
          })
        } else {
          this.$dialog({
            title: '温馨提示',
            content: '密码修改成功',
            footBtn: false,
            width: '20%',
            dialogType: 'success'
          })
          this.isEdit = true
          this.resetForm = Object.assign({}, defaultResetForm)
        }
      })
    }
  }
}
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #fff;
$cursor: #fff;

// @supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
// //   .login-container .el-input input {
// //     // color: $cursor;
// //   }
// // }

/* reset element-ui css */
.login-container {
  .login {
    margin-top: 64px;
  }
  .loginelse {
    margin-top: 19px;
  }
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;
    font-size: 16px;
    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      // color: $light_gray;
      height: 47px;
      // caret-color: $cursor;

      &:-webkit-autofill {
        // box-shadow: 0 0 0px 1000px #fff inset !important;
        // -webkit-text-fill-color: $cursor !important;
      }
    }
  }
  .userNameItem {
    margin-bottom: 17px;
    border: 1px solid #e5e5e5;
    height: 48px;

    .el-select {
      width: 100%;

      .el-input {
        width: 100%;

        .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          padding: 0 15px;
        }
      }
    }
  }
  .passWordItem {
    // margin-bottom: 38px;
    border: 1px solid #e5e5e5;
    // width: 300px;
    height: 48px;

    // 密码遮罩样式 - 默认显示圆点
    .password-mask input {
      -webkit-text-security: disc !important;
      text-security: disc !important;
    }

    // 密码明文样式 - 点击眼睛后显示明文
    .password-plain input {
      -webkit-text-security: none !important;
      text-security: none !important;
    }
  }
  .editMargin {
    margin-bottom: 6px !important;
  }
  .el-form-item__content {
    line-height: 17px !important;
    color: rgba(102, 102, 102, 1);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .el-form-item {
    // border: 1px solid rgba(255, 255, 255, 0.1);
    // background: rgba(0, 0, 0, 0.1);
    background: #fff;
    border-radius: 5px;
    color: #454545;
  }
  .el-checkbox__label {
    font-size: 15px;
    color: #999;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: rgba(0, 184, 130, 1);
  }
  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: rgba(0, 184, 130, 1);
  }
  .el-checkbox__inner:hover {
    border-color: rgba(0, 184, 130, 1);
  }
  .el-checkbox__inner {
    width: 16px;
    height: 16px;
  }
  .el-checkbox__inner::after {
    height: 12px;
    left: 6px;
  }
}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  height: 100%;
  background-size: 100%;
  .login-form {
    position: relative;
    width: 300px;
    max-width: 100%;
    padding: 0px 0px 160px;
    margin: 0 auto;
    overflow: hidden;
    .loginText {
      font-size: 18px;
    }
    .registered {
      font-size: 16px;
      color: #666;
      margin-bottom: 13px;
      display: inline-block;
      width: 100%;
      font-weight: bold;
    }
    .userService {
      display: flex;
      justify-content: space-between;
      height: 62px;
      font-size: 20px;
    }
    .forgotPassword {
      color: rgba(0, 184, 130, 1);
      font-size: 15px;
      cursor: pointer;
    }
  }

  // .tips {
  //   font-size: 14px;
  //   color: #fff;
  //   margin-bottom: 10px;

  //   span {
  //     &:first-of-type {
  //       margin-right: 16px;
  //     }
  //   }
  // }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;
    // margin-bottom: 96px;
    // margin-bottom: 64px;
    margin-top: 73px;
    .title {
      font-size: 40px;
      color: rgba(40, 178, 111, 1);
      margin: 0px auto 15px auto;
      text-align: center;
      font-weight: bold;
    }
    .line {
      text-align: center;
      color: #999;
      margin: 0;
      opacity: 0.6;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 14px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .bind-tips {
    color: #666;
    font-size: 14px;
    margin-bottom: 14px;
  }
  .bind-field {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    .bind-label {
      width: 70px;
      color: #333;
      font-size: 14px;
      flex-shrink: 0;
    }
  }
  .dialog-footer {
    text-align: center;
    padding-bottom: 12px;
  }
  .row-bg {
    width: 100%;
    .loginlogo {
      width: 672px;
      height: 612px;
      border-radius: 20px 0 0 20px;
      box-shadow: 6px 11px 12px 1px rgba(52, 52, 52, 0.19);
    }

    .loginItem {
      height: 612px;
      width: 513px;
      background: #fff;
      border-radius: 0 20px 20px 0px;
      box-shadow: 6px 11px 12px 1px rgba(52, 52, 52, 0.19);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue